import { deliverableDownloadPath } from "@repo/realtime/events/deliverable-download-path";
import { formatAttachmentSize } from "@repo/realtime/events/format-attachment-size";

import { out } from "../output/out";
import type { DeliverablePart } from "@repo/realtime/events/deliverable-part";

/** The durable auth-gated route: a signed Blob URL in a log is replayable. */
export function formatDeliverablePart(
  part: DeliverablePart,
  sessionId: string,
  baseUrl: string,
): string {
  const entries = part.archive ? `, ${part.archive.entryCount} entries` : "";
  const size = `${formatAttachmentSize(part.sizeBytes)}${entries}`;
  const caption = part.caption ? ` - ${out.cell(part.caption)}` : "";
  const link = `${baseUrl}${deliverableDownloadPath(sessionId, part.pathname)}`;
  return `${out.paint("attach", "dim")} ${out.cell(part.name)} ${out.paint(`(${size})`, "dim")}${caption}\n       ${out.cell(link)}`;
}
